import slice from './slice';

export const {
  setMapType,
  setMapZoom,
  setMapCenter,
  setMapLocation,
  resetMapLocation,
  setRulerActive,
  addRulerPoint,
  updateRulerPoint,
  insertRulerPoint,
  removeRulerPoint,
  clearRulerPoints,
} = slice.actions;